import Swal from 'sweetalert2';

const SwalCustom = Swal.mixin({
  cancelButtonColor: '#EB6A79',
  confirmButtonColor: '#62C375',
  confirmButtonText: 'Ok',
  cancelButtonText: 'Close',
});

export const swalTimer = SwalCustom.mixin({
  toast: true,
  position: 'bottom',
  showConfirmButton: false,
  timer: 3000,
  didOpen: swal => {
    swal.addEventListener('mouseenter', SwalCustom.stopTimer);
    swal.addEventListener('mouseleave', SwalCustom.resumeTimer);
  },
});

export const swalConfirm = SwalCustom.mixin({
  confirmButtonText: 'Ya',
  cancelButtonText: 'Tidak',
  showCancelButton: true,
  reverseButtons: true,
  icon: 'warning',
});

export const swalDelete = swalConfirm.mixin({
  backdrop: true,
  showLoaderOnConfirm: true,
  allowOutsideClick: () => !SwalCustom.isLoading(),
});

export const swalSuccess = SwalCustom.mixin({
  icon: 'success',
});

export const swalWarning = SwalCustom.mixin({
  icon: 'warning',
});

export const swalError = SwalCustom.mixin({
  icon: 'error',
});

export const swalInfo = SwalCustom.mixin({
  icon: 'info',
});

export const swalQuestion = SwalCustom.mixin({
  icon: 'question',
});

export const getMessage = (e: any) =>
  typeof e === 'object' ? e.data?.message || e.message : e;

export const swalConfirmDelete = (
  type: string,
  name: string,
  preConfirm: () => Promise<any>,
  callback: () => void,
) => {
  swalDelete
    .fire({
      html: `Are you sure want to delete this ${type}?`,
      preConfirm,
    })
    .then(v => {
      if (v.value) {
        callback();
        swalSuccess.fire({
          title: 'Success delete data!',
          text: `Data ${type} has been deleted`,
        });
      }
    });
};
